module.exports = __webpack_public_path__ + "img/PL08345.9e646b6a.png";